export default "__VITE_PUBLIC_ASSET__9f561006__"